"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SampleChainlink__factory = void 0;
var ethers_1 = require("ethers");
var SampleChainlink__factory = /** @class */ (function (_super) {
    __extends(SampleChainlink__factory, _super);
    function SampleChainlink__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SampleChainlink__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    SampleChainlink__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    SampleChainlink__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SampleChainlink__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SampleChainlink__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    return SampleChainlink__factory;
}(ethers_1.ContractFactory));
exports.SampleChainlink__factory = SampleChainlink__factory;
var _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "val",
                type: "uint256",
            },
        ],
        name: "executeWithPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b50739326bfa02add2366b30bacb125260af6410313316000806101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055506102d3806100746000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c8063b2d8c2f514610030575b600080fd5b61004a60048036038101906100459190610164565b610060565b6040516100579190610213565b60405180910390f35b60008060008054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663feaf968c6040518163ffffffff1660e01b815260040160a06040518083038186803b1580156100c957600080fd5b505afa1580156100dd573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610101919061018d565b50505091505080915050919050565b60008151905061011f81610258565b92915050565b6000813590506101348161026f565b92915050565b6000815190506101498161026f565b92915050565b60008151905061015e81610286565b92915050565b60006020828403121561017657600080fd5b600061018484828501610125565b91505092915050565b600080600080600060a086880312156101a557600080fd5b60006101b38882890161014f565b95505060206101c488828901610110565b94505060406101d58882890161013a565b93505060606101e68882890161013a565b92505060806101f78882890161014f565b9150509295509295909350565b61020d81610238565b82525050565b60006020820190506102286000830184610204565b92915050565b6000819050919050565b6000819050919050565b600069ffffffffffffffffffff82169050919050565b6102618161022e565b811461026c57600080fd5b50565b61027881610238565b811461028357600080fd5b50565b61028f81610242565b811461029a57600080fd5b5056fea2646970667358221220b0654123d850f7ea8bff670c48e0b58a25472d3494351120358219b57dab73df64736f6c63430008020033";
//# sourceMappingURL=SampleChainlink__factory.js.map